import request from '@/utils/request'

export function login (data) {
  return request({
    url: 'token/login',
    name: 'login',
    method: 'post',
    data,
    transformRequest: [
      function (data) {
        let ret = ''
        for (const it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export function logout (token) {
  return request({
    url: 'token/logout',
    method: 'delete'
  })
}

export function switchRole (params) {
  return request({
    url: `token/role/${params}`,
    name: 'roleChange',
    method: 'patch',
    data: {
      platform: 'pc'
    },
    transformRequest: [
      function (data) {
        let ret = ''
        for (const it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export function changeKindergarten (kindergartenId) {
  return request({
    url: `token/kindergarten/${kindergartenId}?platform=pc`,
    method: 'patch'
  })
}

// 阿里云上传 获取stsToken
export function getStsTokenData (params) {
  return request({
    url: 'token/sts',
    method: 'get',
    params
  })
}

export function loginWx (data) {
  return request({
    url: 'token/login_wechat',
    method: 'post',
    data,
    transformRequest: [
      function (data) {
        let ret = ''
        for (const it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}



// WEBPACK FOOTER //
// ./src/api/token.js